const {client, loadToken} = require('services/api/client');
export { loadToken };

export async function getAllClearways() {
  var { data } = await client.get(`/clearways/event`);
  return data;
}

export async function getClearwaysWithYearAndMonth(year, month) {
  // console.log(client)
  var { data } = await client.get(`/clearways/year/${year}/month/${month}`);
  return data;
}

export async function getClearwayEventWithID(id) {
  var { data } = await client.get(`/clearways/event/${id}`);
  return data;
}

export async function saveClearwayEventWithID(id, data) {
  var { data } = await client.put(`/clearways/event/${id}`, data);
  return data;
}

export async function createClearwayEvent(data){
  await client.post('clearways/event', data);
}

export async function getClearwayEventWithData(id, data){
  var { data } = await client.get(`/clearways/duplicate/${id}/${data.display_time}/${data.start_time}/${data.end_time}/${data.name}`);
  return data;
}

export async function deleteSelectedEvent(event_id){
  var { data } = await client.put(`/clearways/event/soft-delete/${event_id}`);
  return data;
}

export async function getClearwaysBetweenTimes(start_time, end_time) {
  var { data } = await client.get(`/clearways/start/${start_time}/end/${end_time}`);
  return data;
}

const all = {
  loadToken, getAllClearways, getClearwaysWithYearAndMonth, getClearwayEventWithID, saveClearwayEventWithID, createClearwayEvent, getClearwayEventWithData, deleteSelectedEvent, getClearwaysBetweenTimes
};

export default all;